import React from "react";
import useCopyToClipboard from "../../utils/HandleCopyClipboard";

interface CopyButtonProps {
  copyText: string;
  copyMessage: string;
  fillColor?: string;
  iconColor?: string;
  copyIconSize?: number;
  buttonSize?: string;
  borderRadius?: string;
  borderColor?: string;
}

const CopyButton: React.FC<CopyButtonProps> = ({
  copyText,
  copyMessage,
  copyIconSize = 16,
  buttonSize = "20px",
  borderRadius = "4px",
  fillColor = "bg-bg-base",
  iconColor = "text-icon-base",
  borderColor = "border-border-subtle",
}) => {
  const { handleCopyClick } = useCopyToClipboard();

  return (
    <button
      type="button"
      aria-label="Copy"
      className={`flex justify-center items-center cursor-pointer shadow-sm ${fillColor} border ${borderColor} ${iconColor} transition-colors duration-300 hover:bg-bg-button-secondary`}
      style={{
        width: buttonSize,
        height: buttonSize,
        borderRadius: borderRadius,
      }}
      onClick={() =>
        handleCopyClick({
          copyText: copyText,
          copyMessage: copyMessage,
        })
      }
    >
      <span
        className="material-symbols-outlined leading-none"
        style={{ fontSize: `${copyIconSize}px` }}
      >
        content_copy
      </span>
    </button>
  );
};

export default CopyButton;
